import {safeJSONparse} from "../../common/util/safeJSONparse";

export const CHANNEL_CREATE_STEP_OPTIONS = 2;
export const CHANNEL_CREATE_STEP_GRANT = 3;
export const CHANNEL_CREATE_STEP_POST_GRANT = 4;
export const CHANNEL_CREATE_STEP_FINISH = 5;

function getChannelCreateMetadata(channelDefOrMetadata) {
    if (!channelDefOrMetadata) {
        return {};
    }

    if (typeof channelDefOrMetadata === 'string') {
        return safeJSONparse(channelDefOrMetadata) || {};
    }

    if (channelDefOrMetadata.metadata) {
        return safeJSONparse(channelDefOrMetadata.metadata) || {};
    }

    return channelDefOrMetadata;
}

export function getFirstChannelCreateStep(channelDefOrMetadata) {
    let metadata = getChannelCreateMetadata(channelDefOrMetadata);

    if (metadata.hasOptionsOnCreate) {
        return CHANNEL_CREATE_STEP_OPTIONS;
    }

    if (metadata.hasGrant) {
        return CHANNEL_CREATE_STEP_GRANT;
    }

    if (metadata.hasOptionsAfterGrant) {
        return CHANNEL_CREATE_STEP_POST_GRANT;
    }

    return CHANNEL_CREATE_STEP_FINISH;
}

export function getNextChannelCreateStep(channelDefOrMetadata, currentStep) {
    let metadata = getChannelCreateMetadata(channelDefOrMetadata);

    if (currentStep === CHANNEL_CREATE_STEP_GRANT) {
        if (metadata.hasOptionsAfterGrant) {
            return CHANNEL_CREATE_STEP_POST_GRANT;
        }

        return CHANNEL_CREATE_STEP_FINISH;
    }

    if (currentStep === CHANNEL_CREATE_STEP_POST_GRANT) {
        return CHANNEL_CREATE_STEP_FINISH;
    }

    if (metadata.hasGrant) {
        return CHANNEL_CREATE_STEP_GRANT;
    }

    if (metadata.hasOptionsAfterGrant) {
        return CHANNEL_CREATE_STEP_POST_GRANT;
    }

    return CHANNEL_CREATE_STEP_FINISH;
}
